import { playbookDo, playbookDont } from "@/mocks/media";

export default function Playbook() {
  const doItems = playbookDo;
  const dontItems = playbookDont;

  return (
    <section id="playbook" className="bg-foreground-950 py-16 text-background-50 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-accent-500" />
            <span className="text-xs font-medium uppercase tracking-[0.25em] text-accent-400">
              CRISIS HANDBOOK
            </span>
          </div>
          <h2 className="mt-3 font-heading text-2xl font-bold text-white md:text-4xl">
            给从业者的一页公关手册
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-300 md:text-base">
            无论身处品牌方、艺人团队还是内容侧，危机来临时真正管用的，往往是一些朴素却难坚持的原则。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-foreground-700/60 bg-foreground-900/50 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500">
                <i className="ri-check-line text-lg text-background-50" />
              </span>
              <h3 className="font-heading text-lg font-semibold text-white">值得坚持的做法</h3>
            </div>
            <ul className="mt-6 flex flex-col gap-4">
              {doItems.map((item) => (
                <li key={item.title} className="flex gap-3">
                  <i className="ri-checkbox-circle-fill mt-0.5 shrink-0 text-primary-400" />
                  <div>
                    <p className="text-sm font-semibold text-white">{item.title}</p>
                    <p className="mt-1 text-xs leading-6 text-foreground-400">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-foreground-700/60 bg-foreground-900/50 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-700">
                <i className="ri-close-line text-lg text-background-50" />
              </span>
              <h3 className="font-heading text-lg font-semibold text-white">容易踩雷的禁区</h3>
            </div>
            <ul className="mt-6 flex flex-col gap-4">
              {dontItems.map((item) => (
                <li key={item.title} className="flex gap-3">
                  <i className="ri-error-warning-fill mt-0.5 shrink-0 text-accent-400" />
                  <div>
                    <p className="text-sm font-semibold text-white">{item.title}</p>
                    <p className="mt-1 text-xs leading-6 text-foreground-400">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}